module.exports = __webpack_public_path__ + "img/kort-4.6f89865f.jpg";